// One column contract for student roster exports and the onboarding template.
// readonly_id lets an edited export find the same student on re-upload.
export const studentCsvColumns = [
  { header: "name", value: (s) => s.name },
  { header: "email", value: (s) => s.email },
  { header: "password", value: (s) => s.password || "" },
  { header: "grade", value: (s) => s.grade },
  { header: "section", value: (s) => s.section },
  { header: "parent_email", value: (s) => s.parent_email },
  { header: "parent_name", value: (s) => s.parent_name },
  { header: "parent_password", value: (s) => s.parent_password || "" },
  { header: "readonly_id", value: (s) => s.id },
  { header: "roll_no", value: (s) => s.roll_no },
  { header: "readonly_classes", value: (s) =>
    (s.enrolled_classes || []).map((c) => c.name || [c.grade, c.section].filter(Boolean).join(" ")) },
  { header: "school_name", value: (s) => s.school_name },
  { header: "date_of_birth", value: (s) => s.date_of_birth },
  { header: "phone", value: (s) => s.phone },
  { header: "father_name", value: (s) => s.father_name },
  { header: "mother_name", value: (s) => s.mother_name },
];

export const studentCsvTemplateRows = [
  { name: "John Doe", email: "john@example.com", password: "Secret123", grade: "9", section: "A",
    parent_email: "parent.doe@example.com", parent_name: "Mary Doe", parent_password: "FamilyPass123" },
  { name: "Jane Doe", email: "jane@example.com", password: "Pass456", grade: "10", section: "B",
    parent_email: "parent.doe@example.com", parent_name: "Mary Doe", parent_password: "FamilyPass123" },
  { name: "Sam Smith", email: "sam@example.com", password: "Pass789", grade: "9", section: "A" },
];
